module.exports = __webpack_public_path__ + "img/Attributes.04280de3.jpg";